import { ReservationFormikForm } from '@go-client/components/Formik/ReservationFormik';
import { groupBy } from '@go-shared/lib/functional';
import { calculatePricingHelper } from '@go-shared/lib/reserve';
import { ReservableEventTemplateSnapshot } from '@go-shared/types/reservable';

export function calculateReservationFormikPricing(
  values: ReservationFormikForm,
  eventSnapshot: ReservableEventTemplateSnapshot
) {
  const ticketGroups = groupBy(values.tickets, t => t.ticketId);

  const record = {
    eventSnapshot,
    priceOverrides: values.priceOverrides,
    tickets: Object.keys(ticketGroups).map(ticketId => ({
      quantity: ticketGroups[ticketId].length,
      ticket: ticketGroups[ticketId][0]._ticket,
    })),
    packages: values.packages.map(p => ({
      quantity: p.quantity,
      package: p._package,
    })),
    addons: values.addons.map(a => ({
      quantity: a.quantity,
      addon: a._addon,
    })),
  };

  return calculatePricingHelper([record]);
}
